import { AxiosError } from 'axios';
import { toast } from '@shared/utils/toast';
interface AppError {
  status: string;
  message: string;
}

const CHECKOUT_CURRENCY_ERROR_MESSAGES: Record<string, string> = {
  CURRENCY_MISMATCH:
    'La moneda del pago no coincide con la moneda de esta operación.',
  OPERATION_CURRENCY_UNKNOWN:
    'No pudimos determinar la moneda de esta operación. Intentá de nuevo en unos minutos.',
};

export function handleAxiosError(error: unknown, withToast = false): AppError {
  console.error(error);

  let appError: AppError;
  if (error instanceof AxiosError) {
    const axiosError = error as AxiosError<{ message: string; code?: string }>;
    const status = axiosError.response?.status.toString() ?? 'UNKNOWN';
    const code = axiosError.response?.data.code;
    const message =
      (code && CHECKOUT_CURRENCY_ERROR_MESSAGES[code]) ??
      axiosError.response?.data.message ??
      error.message;
    appError = {
      status: status,
      message: message,
    };
  } else if (error instanceof Error) {
    appError = {
      status: 'UNKNOWN',
      message: error.message || 'Ocurrió un error desconocido',
    };
  } else {
    appError = {
      status: 'UNKNOWN',
      message: 'Ocurrió un error desconocido',
    };
  }

  if (withToast) {
    toast.error({
      title: 'Ocurrió un error.',
      message: appError.message,
    });
  }

  return appError;
}
